import { render, staticRenderFns } from "./first-case-study.vue?vue&type=template&id=76985736&"
import script from "./first-case-study.vue?vue&type=script&lang=js&"
export * from "./first-case-study.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports